/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  ConsentAcceptanceSummaryDto,
  ConsentDtoV2,
  FindByOrganisationIdParams,
  FindConsentsByIdsParams,
  FindConsentsParams,
  GetFunnelSuitableParams,
  GetMissingParams,
  SendNotificationForAwxMigrationCampaignParams,
  SendNotificationForEmiLicenceCampaignParams,
} from '../dto'
import { HttpClient, RequestParams } from './http-client'

export class ConsentControllerV2<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags consent-controller-v-2
   * @name SendNotificationForEmiLicenceCampaign
   * @request POST:/api/v2/organisation/consents/campaign/emi-licence/notify
   */
  sendNotificationForEmiLicenceCampaign = (
    query: SendNotificationForEmiLicenceCampaignParams,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v2/organisation/consents/campaign/emi-licence/notify`,
      method: 'POST',
      query: query,
      ...params,
    })

  static sendNotificationForEmiLicenceCampaignPath =
    '/v2/organisation/consents/campaign/emi-licence/notify'
  static sendNotificationForEmiLicenceCampaignMethod = 'POST'
  /**
   * No description
   *
   * @tags consent-controller-v-2
   * @name SendNotificationForAwxMigrationCampaign
   * @request POST:/api/v2/organisation/consents/campaign/awx-migration/notify
   */
  sendNotificationForAwxMigrationCampaign = (
    query: SendNotificationForAwxMigrationCampaignParams,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v2/organisation/consents/campaign/awx-migration/notify`,
      method: 'POST',
      query: query,
      ...params,
    })

  static sendNotificationForAwxMigrationCampaignPath =
    '/v2/organisation/consents/campaign/awx-migration/notify'
  static sendNotificationForAwxMigrationCampaignMethod = 'POST'
  /**
   * No description
   *
   * @tags consent-controller-v-2
   * @name FindByOrganisationId
   * @request GET:/api/v2/organisation/consents
   */
  findByOrganisationId = (query: FindByOrganisationIdParams, params: RequestParams = {}) =>
    this.http.request<ConsentDtoV2[], any>({
      path: `/v2/organisation/consents`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static findByOrganisationIdPath = '/v2/organisation/consents'
  static findByOrganisationIdMethod = 'GET'
  /**
   * No description
   *
   * @tags consent-controller-v-2
   * @name GetAcceptanceSummaryForEmiLicenceCampaign
   * @request GET:/api/v2/organisation/consents/campaign/emi-licence
   */
  getAcceptanceSummaryForEmiLicenceCampaign = (params: RequestParams = {}) =>
    this.http.request<ConsentAcceptanceSummaryDto, any>({
      path: `/v2/organisation/consents/campaign/emi-licence`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getAcceptanceSummaryForEmiLicenceCampaignPath =
    '/v2/organisation/consents/campaign/emi-licence'
  static getAcceptanceSummaryForEmiLicenceCampaignMethod = 'GET'
  /**
   * No description
   *
   * @tags consent-controller-v-2
   * @name GetAcceptanceSummaryForAwxMigrationCampaign
   * @request GET:/api/v2/organisation/consents/campaign/awx-migration
   */
  getAcceptanceSummaryForAwxMigrationCampaign = (params: RequestParams = {}) =>
    this.http.request<ConsentAcceptanceSummaryDto, any>({
      path: `/v2/organisation/consents/campaign/awx-migration`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getAcceptanceSummaryForAwxMigrationCampaignPath =
    '/v2/organisation/consents/campaign/awx-migration'
  static getAcceptanceSummaryForAwxMigrationCampaignMethod = 'GET'
  /**
   * No description
   *
   * @tags consent-controller-v-2
   * @name FindConsents
   * @request GET:/api/v2/consents
   */
  findConsents = (query: FindConsentsParams, params: RequestParams = {}) =>
    this.http.request<ConsentDtoV2[], any>({
      path: `/v2/consents`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static findConsentsPath = '/v2/consents'
  static findConsentsMethod = 'GET'
  /**
   * No description
   *
   * @tags consent-controller-v-2
   * @name GetMissing
   * @request GET:/api/v2/consents/missing
   */
  getMissing = (query: GetMissingParams, params: RequestParams = {}) =>
    this.http.request<ConsentDtoV2[], any>({
      path: `/v2/consents/missing`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getMissingPath = '/v2/consents/missing'
  static getMissingMethod = 'GET'
  /**
   * No description
   *
   * @tags consent-controller-v-2
   * @name GetFunnelSuitable
   * @request GET:/api/v2/consents/funnel-suitable/{country}
   */
  getFunnelSuitable = (
    { country, ...query }: GetFunnelSuitableParams,
    params: RequestParams = {},
  ) =>
    this.http.request<ConsentDtoV2, any>({
      path: `/v2/consents/funnel-suitable/${country}`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getFunnelSuitablePath = '/v2/consents/funnel-suitable/${country}'
  static getFunnelSuitableMethod = 'GET'
  /**
   * No description
   *
   * @tags consent-controller-v-2
   * @name FindConsentsByIds
   * @request GET:/api/v2/consents/by-ids
   */
  findConsentsByIds = (query: FindConsentsByIdsParams, params: RequestParams = {}) =>
    this.http.request<ConsentDtoV2[], any>({
      path: `/v2/consents/by-ids`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static findConsentsByIdsPath = '/v2/consents/by-ids'
  static findConsentsByIdsMethod = 'GET'
  /**
   * No description
   *
   * @tags consent-controller-v-2
   * @name FindConsentsByApplicationId
   * @request GET:/api/v2/application/consents
   */
  findConsentsByApplicationId = (params: RequestParams = {}) =>
    this.http.request<ConsentDtoV2[], any>({
      path: `/v2/application/consents`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static findConsentsByApplicationIdPath = '/v2/application/consents'
  static findConsentsByApplicationIdMethod = 'GET'
}
